/**
 * Track app download link clicks in Mixpanel.
 * Used for iOS App Store, Google Play, and Android APK links.
 */

import mixpanel from "mixpanel-browser";
import { getPlatform } from "@/lib/mobile-wallet-utils";

export type AppDownloadDestination =
  | "ios_app_store"
  | "google_play"
  | "android_apk";

/**
 * Track an app download link click.
 * Use for links with target="_blank" or buttons that use window.open().
 */
export function trackAppDownloadClick(
  destination: AppDownloadDestination,
  source: string
): void {
  if (typeof mixpanel !== "undefined" && mixpanel?.track) {
    mixpanel.track("app_download_link_clicked", {
      destination,
      source,
      platform: getPlatform(),
    });
  }
}

/**
 * Track an app download link click, then run a callback (e.g. navigate).
 * Use for same-tab navigation (e.g. APK download) so the track request
 * completes before the page unloads.
 */
export function trackAppDownloadClickWithCallback(
  destination: AppDownloadDestination,
  source: string,
  onComplete: () => void
): void {
  if (typeof mixpanel !== "undefined" && mixpanel?.track) {
    mixpanel.track(
      "app_download_link_clicked",
      {
        destination,
        source,
        platform: getPlatform(),
      },
      onComplete
    );
  } else {
    onComplete();
  }
}
